
import React from "react";
import "./Recliner.css";

import {
  FaCheckCircle,
  FaArrowRight,
  FaWhatsapp,
  FaPhone,
  FaChair,
  FaTools,
  FaWrench,
  FaShieldAlt,
  FaCouch,
  FaCog,
} from "react-icons/fa";

import Footer from "../footer/Footer";
import Location from "../location/Location";
import Navbar from "../navbar/Navbar";
import Offer from "../offer/Offer";

export default function Recliner() {
  const PHONE = "+919318333680";
  const WHATSAPP = "919318333680";

  const openWhatsApp = (message) => {
    window.open(
      `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(message)}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const services = [
    {
      icon: <FaCog />,
      title: "Recliner Mechanism Repair",
      text: "Repair of damaged or stuck recliner mechanisms for smoother and more reliable movement.",
    },
    {
      icon: <FaTools />,
      title: "Recliner Cable Repair",
      text: "Broken, loose or damaged recliner cables are checked and repaired or replaced.",
    },
    {
      icon: <FaChair />,
      title: "Recliner Handle Repair",
      text: "We repair or replace damaged recliner handles and operating components.",
    },
    {
      icon: <FaCouch />,
      title: "Recliner Cushion Repair",
      text: "Restore comfort with cushion, foam and internal support repair according to your recliner.",
    },
  ];

  const process = [
    {
      number: "01",
      title: "Inspection",
      text: "We inspect the recliner mechanism, handle, cable, frame and seating condition.",
    },
    {
      number: "02",
      title: "Problem Check",
      text: "Our technician identifies the actual cause of the recliner problem.",
    },
    {
      number: "03",
      title: "Repair",
      text: "Damaged parts are repaired or replaced with suitable components.",
    },
    {
      number: "04",
      title: "Final Testing",
      text: "The recliner is tested for smooth movement, comfort and proper support.",
    },
  ];

  return (
    <>
      <Navbar />

      {/* ================= HERO ================= */}
      <section className="rk-recliner-hero">
        <div className="container">
          <div className="row align-items-center g-5">

            {/* LEFT CONTENT */}
            <div className="col-lg-6">
              <div className="rk-recliner-content">

                <div className="rk-recliner-eyebrow">
                  <span></span>
                  PROFESSIONAL RECLINER REPAIR SERVICE
                </div>

                <h1>
                  Fix Your Recliner's
                  <br />
                  <em>Comfort & Movement.</em>
                </h1>

                <p className="rk-recliner-intro">
                  Professional recliner repair service in Noida for stuck,
                  damaged and uncomfortable recliners. We repair mechanisms,
                  cables, handles, cushions and internal support to restore
                  smooth movement and seating comfort.
                </p>

                <div className="rk-recliner-actions">

                  <a
                    href={`tel:${PHONE}`}
                    className="rk-recliner-call"
                  >
                    <FaPhone />

                    <span>
                      <small>CALL OUR EXPERT</small>
                      Call Now
                    </span>
                  </a>

                  <button
                    type="button"
                    className="rk-recliner-whatsapp"
                    onClick={() =>
                      openWhatsApp(
                        "Hi RK Sofa Works, I need recliner repair service in Noida."
                      )
                    }
                  >
                    <FaWhatsapp />
                    WhatsApp Us
                    <FaArrowRight />
                  </button>

                </div>

                <div className="rk-recliner-trust">

                  <div>
                    <FaCheckCircle />
                    <span>Experienced Craftsmen</span>
                  </div>

                  <div>
                    <FaCheckCircle />
                    <span>Quality Components</span>
                  </div>

                  <div>
                    <FaCheckCircle />
                    <span>Doorstep Inspection</span>
                  </div>

                </div>

              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-6">

              <div className="rk-recliner-image-box">

                <div className="rk-recliner-image-frame">

                  <img
                    src="/img/sofa_cleaner.png"
                    alt="Recliner Repair Service in Noida"
                  />

                  <div className="rk-recliner-image-gradient"></div>

                </div>

                <div className="rk-recliner-service-card">

                  <div className="rk-recliner-service-icon">
                    <FaWrench />
                  </div>

                  <div>
                    <strong>Recliner Repair</strong>
                    <span>Restore Comfort & Movement</span>
                  </div>

                </div>

              </div>

            </div>

          </div>
        </div>
      </section>

      {/* ================= STATS ================= */}
      <section className="rk-recliner-stats">
        <div className="container">

          <div className="rk-recliner-stats-inner">

            <div className="rk-recliner-stat">
              <strong>18+</strong>
              <span>Years Experience</span>
            </div>

            <div className="rk-recliner-divider"></div>

            <div className="rk-recliner-stat">
              <strong>2500+</strong>
              <span>Sofas Serviced</span>
            </div>

            <div className="rk-recliner-divider"></div>

            <div className="rk-recliner-stat">
              <strong>100%</strong>
              <span>Quality Focus</span>
            </div>

            <div className="rk-recliner-divider"></div>

            <div className="rk-recliner-stat">
              <strong>Noida</strong>
              <span>Doorstep Service</span>
            </div>

          </div>

        </div>
      </section>

      {/* ================= SERVICES ================= */}
      <section className="rk-recliner-services">

        <div className="container">

          <div className="rk-recliner-heading">

            <span>WHAT WE REPAIR</span>

            <h2>
              Complete Recliner
              <br />
              <em>Repair Solutions</em>
            </h2>

            <p>
              From stuck mechanisms to damaged handles and cushions, we
              identify the actual problem and provide the right repair.
            </p>

          </div>

          <div className="row g-4">

            {services.map((item, index) => (
              <div
                className="col-sm-6 col-lg-3"
                key={index}
              >
                <article className="rk-recliner-service-card-box">

                  <div className="rk-recliner-card-top">

                    <span>
                      0{index + 1}
                    </span>

                    <div className="rk-recliner-card-icon">
                      {item.icon}
                    </div>

                  </div>

                  <h3>{item.title}</h3>

                  <p>{item.text}</p>

                  <div className="rk-recliner-card-line"></div>

                  <button
                    type="button"
                    onClick={() =>
                      openWhatsApp(
                        `Hi RK Sofa Works, I need ${item.title.toLowerCase()} service for my recliner.`
                      )
                    }
                  >
                    Enquire Now
                    <FaArrowRight />
                  </button>

                </article>
              </div>
            ))}

          </div>

        </div>
      </section>

      {/* ================= WHY CHOOSE US ================= */}
      <section className="rk-recliner-quality">

        <div className="container">

          <div className="row align-items-center g-5">

            <div className="col-lg-5">

              <div className="rk-recliner-quality-image">

                <img
                  src="/img/sofa_cleaner_1.png"
                  alt="Professional recliner repair work"
                />

                <div className="rk-recliner-quality-label">
                  <FaShieldAlt />

                  <span>
                    Smooth Movement
                    <br />
                    Comfortable Seating
                  </span>
                </div>

              </div>

            </div>

            <div className="col-lg-7">

              <div className="rk-recliner-quality-content">

                <span className="rk-recliner-small-heading">
                  WHY CHOOSE RK SOFA WORKS
                </span>

                <h2>
                  Bring Back Your Recliner's
                  <br />
                  <em>Original Comfort.</em>
                </h2>

                <p>
                  A faulty recliner mechanism, cable or handle can make your
                  furniture difficult and uncomfortable to use. Our repair
                  service focuses on finding the actual issue and restoring
                  smooth operation.
                </p>

                <div className="rk-recliner-quality-list">

                  <div>
                    <FaCheckCircle />

                    <div>
                      <strong>Complete Inspection</strong>
                      <span>
                        We check the mechanism, cable, handle, frame and
                        seating system.
                      </span>
                    </div>
                  </div>

                  <div>
                    <FaCheckCircle />

                    <div>
                      <strong>Suitable Components</strong>
                      <span>
                        Repair and replacement components are selected according
                        to the recliner.
                      </span>
                    </div>
                  </div>

                  <div>
                    <FaCheckCircle />

                    <div>
                      <strong>Comfort Restoration</strong>
                      <span>
                        We focus on restoring comfortable seating and smooth
                        recliner movement.
                      </span>
                    </div>
                  </div>

                  <div>
                    <FaCheckCircle />

                    <div>
                      <strong>Professional Work</strong>
                      <span>
                        Repair work is handled by experienced sofa and
                        recliner craftsmen.
                      </span>
                    </div>
                  </div>

                </div>

                <button
                  type="button"
                  className="rk-recliner-quality-btn"
                  onClick={() =>
                    openWhatsApp(
                      "Hi RK Sofa Works, I want to get my recliner inspected."
                    )
                  }
                >
                  Get Recliner Inspection
                  <FaArrowRight />
                </button>

              </div>

            </div>

          </div>

        </div>
      </section>

      {/* ================= PROCESS ================= */}
      <section className="rk-recliner-process">

        <div className="container">

          <div className="rk-recliner-heading">

            <span>HOW IT WORKS</span>

            <h2>
              Our Recliner Repair
              <br />
              <em>Process</em>
            </h2>

            <p>
              A simple process from inspection to final movement and comfort
              check.
            </p>

          </div>

          <div className="rk-recliner-process-grid">

            {process.map((item, index) => (
              <div
                className="rk-recliner-process-item"
                key={item.number}
              >

                <div className="rk-recliner-process-number">
                  {item.number}
                </div>

                <div className="rk-recliner-process-content">

                  <h3>{item.title}</h3>

                  <p>{item.text}</p>

                </div>

                {index !== process.length - 1 && (
                  <div className="rk-recliner-process-arrow">
                    <FaArrowRight />
                  </div>
                )}

              </div>
            ))}

          </div>

        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="rk-recliner-cta">

        <div className="container">

          <div className="rk-recliner-cta-inner">

            <div>

              <span>
                RECLINER STUCK OR NOT WORKING PROPERLY?
              </span>

              <h2>
                Let Us Check Your
                <br />
                Recliner.
              </h2>

              <p>
                Send us a few photos or a short video of your recliner and our
                team can guide you about the possible repair.
              </p>

            </div>

            <button
              type="button"
              onClick={() =>
                openWhatsApp(
                  "Hi RK Sofa Works, my recliner is not working properly. I am sharing photos/videos for inspection."
                )
              }
            >
              <FaWhatsapp />
              Send Recliner Photos
              <FaArrowRight />
            </button>

          </div>

        </div>
      </section>

      <Offer />
      <Location />
      <Footer />
    </>
  );
}
